



















































































import Vue, { PropType } from 'vue';
import { Image, genDownloadOriginalImageUrlEx, uploadImageEx } from '@/modules/image';

export type DataType = {
  // innerImage: Image | null;
  // uploadedImage: string | null;
  // innerImages: Image[];
  // imageUrls: string[];
  // genDownloadOriginalImageUrl: Function;
  // uploadImage: Function;
  dragover: boolean;
};

export default Vue.extend({
  name: 'GImageInput',
  props: {
    owner: { type: String as PropType<string>, required: true },
    label: { type: String as PropType<string> },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    name: { type: String as PropType<string>, required: true },
    multiple: { type: Boolean as PropType<boolean>, default: false },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    // image: { type: Object as PropType<Image>, default: null },
    // images: { type: Array as PropType<Image[]>, default: () => [] },
    error: { type: Array as PropType<string[]>, default: () => [] },
    validate: { type: Function as PropType<Function>, default: () => false },
    reset: { type: Function as PropType<Function>, default: () => false },
    caution: { type: String as PropType<string>, required: true },
    withDescription: { type: Boolean as PropType<boolean>, default: false },
    value: { type: [Object, Array] as PropType<Image | Image[] | null>, default: null },
  },
  data(): DataType {
    return {
      dragover: false,
    };
  },
  asyncComputed: {
    imageUrls: {
      async get() {
        const us: string[] = [];
        for (const img of this.innerValue) {
          if (!img.id) throw Error('img.id is null');
          const u = await genDownloadOriginalImageUrlEx(
            this.owner,
            img.id,
          );
          us.push(u);
        }
        return us;
      },
      default() {
        return [];
      },
    },
  },
  computed: {
    innerValue: {
      get(): Image[] {
        if (!this.multiple) {
          const val = this.value as Image | null;
          if (val) {
            return [val];
          } else {
            return [];
          }
        } else if (this.value) {
          return this.value as Image[];
        } else {
          return [];
        }
      },
      set(val: Image[]): void {
        if (!this.multiple) {
          if (val[0]) {
            this.$emit('input', val[0]);
          } else {
            this.$emit('input', null);
          }
        } else {
          this.$emit('input', val);
        }
      },
    },
  },
  methods: {
    // async genUrl(img: Image): string {
    //   if (!img.id) throw Error("img.id is null");
    //   const u = await genDownloadOriginalImageUrlEx(
    //     this.owner,
    //     img.id,
    //   );
    // },
    async onFileChange(event: any) {
      try {
        this.$loading(true);
        if (typeof this.reset === 'function') this.reset();

        if (typeof this.validate === 'function') {
          const r = await this.validate(event);
          if (!r.valid) return;
        }

        const files = event.target.files || event.dataTransfer.files;
        if (!this.multiple) {
          if (files.length === 0 || !files[0].type.match(/png|jpg|jpeg|gif/)) return;
          const image = await uploadImageEx(
            this.owner,
            // this.$auth.cid,
            files[0],
            files[0].name,
          );
          if (!image || !image.id) {
            throw Error('Can not get image');
          }
          this.$set(this, 'innerValue', [image]);
        } else {
          for (let i = 0; i < files.length; i++) {
            if (!files[i].type.match(/png|jpg|jpeg|gif/)) return;
          }
          for await (const file of files) {
            const image = await uploadImageEx(
              this.owner,
              // this.$auth.cid,
              file,
              file.name,
            );

            if (!image || !image.id) {
              throw Error('can not get image.id');
            }
            this.innerValue.push(image);
            this.$set(this, 'innerValue', this.innerValue);
            // this.innerValue.push(image);
          }
        }
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.$loading(false);
        console.log('RESET!');
        const el: any = this.$refs.image_input;
        if (el) el.value = '';
      }
    },
    onDelete(): void {
      this.$set(this, 'innerValue', []);
    },
    onUp(index: number): void {
      if (Array.isArray(this.innerValue)) {
        if (index === 0) return;
        const innerVal = this.innerValue.slice(index, index + 1);
        this.innerValue.splice(index, 1);
        this.innerValue.splice(index - 1, 0, innerVal[0]);
        // const uploadedVal = this.imageUrls.slice(index, index + 1);
        // this.imageUrls.splice(index, 1);
        // this.imageUrls.splice(index - 1, 0, uploadedVal[0]);
      }
    },
    onDown(index: number): void {
      if (Array.isArray(this.innerValue)) {
        if (index >= this.innerValue.length - 1) return;
        const innerVal = this.innerValue.slice(index, index + 1);
        this.innerValue.splice(index, 1);
        this.innerValue.splice(index + 1, 0, innerVal[0]);
        // const uploadedVal = this.imageUrls.slice(index, index + 1);
        // this.imageUrls.splice(index, 1);
        // this.imageUrls.splice(index + 1, 0, uploadedVal[0]);
      }
    },
    onDeleteMulti(index: number): void {
      if (Array.isArray(this.innerValue)) {
        this.innerValue.splice(index, 1);
        // this.imageUrls.splice(index, 1);
      }
    },
  },
});
